var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_5921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14286 9.57143C1.95939 9.57143 1 8.61204 1 7.42857V4.21429C1 2.43909 2.43909 1 4.21429 1H27.7857C29.561 1 31 2.43909 31 4.21429V7.42857C31 8.61204 30.0406 9.57143 28.8571 9.57143M3.14286 9.57143V27.7857C3.14286 29.561 4.58195 31 6.35714 31H25.6429C27.4181 31 28.8571 29.561 28.8571 27.7857V9.57143M3.14286 9.57143H28.8571M11.7143 16H19.2143",
    stroke: "current",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 19H35.9004",
    stroke: "current",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9004 16L35.9004 19",
    stroke: "current",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9004 22L35.9004 19",
    stroke: "current",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_5921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.09dc5492f86dfb9b3960c56b94080132.svg";
export { ForwardRef as ReactComponent };